module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-epigraph element-without-heading",
    attrs: {
      "id": "intro-to-memorial"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "intro-to-memorial-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('i', [_vm._v("Why not start at the beginning? I’ll open this initial volume with my very first published story, a short that I wrote on a manual typewriter when I was a sophomore in high school. It was 1977, and I had already wanted to be a writer for years.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("When digging through old boxes and files a few months ago, I came upon my high school scrapbooks and found the magazine that printed the story, a Wisconsin High School Writings publication. I was 14 years old.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Maybe Steven Spielberg will see it now and decide to make it into an epic $200M film! Or maybe not. Nevertheless, I was off and running.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e8f5d2d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introtomemorial.vue
// module id = 78
// module chunks = 0